import { customStyle } from 'styles/functions'

export const saguenay = {
  body_background_color: '#BF2F38',
  header_border_color: '#FFEEE3',

  logo_image_url: 'saguenay.png',
  logo_height: 100,

  token_url: 'saguenay.png',
  token_width: 60,
  token_margin_left: 10,
  token_margin_right: 10,
  token_margin_top: 10,
  number_hidden: true,

  button_color: '#BF2F38',
  button_radius: 15,
  button_text_lineheight: 21.6,
  button_text_size: 18,
  button_text_weight: 400,
  button_padding: '20px 80px',
  button_outlined_as_default: true,

  button_half_border_color: '#636466',

  audio_background_color: '#FFEEE3',

  title_font: 'Arvo, serif',
  title_size: 27,
  title_lineheight: 35.1,
  title_color: '#BF2F38',

  subtitle_color: '#636466',
  subtitle_size: 22.5,
  subtitle_lineheight: 29.25,

  text_font: 'Arvo, serif',
  text_color: '#333',
  text_size: 15,
  text_lineheight: 24.75,

  lock_background_color: '#FFEEE3',
  lock_button_outlined: false,

  separator_color: '#636466',

  footer_border_color: '#FFEEE3',
}

export const saguenay_promotion = {
  ...saguenay,
  card_header_margin_top: 30,
  token_hidden: true,
  number_hidden: true,
  header_hidden: true,
  title_color: 'black',
  body_background_color: '#cecece',
}

export const saguenay_fjord = {
  ...saguenay,
  token_hidden: true,
  number_hidden: true,
  logo_height: 70,

  title_font: 'RightGrotesk',
  subtitle_font: 'PPAgrandir',
  button_font: 'WorkSans',

  title_color: 'black',
  title_size: 33,
  title_weight: 400,

  button_color: '#521261',
  logo_image_url: 'SaguenayFjord.png',

  text_font: 'WorkSans',
  text_color: '#212121',
  body_background_color: '#3b4d7a',
}